var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkmode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5H26C31.2467 0.5 35.5 4.7533 35.5 10V26C35.5 31.2467 31.2467 35.5 26 35.5H10C4.7533 35.5 0.5 31.2467 0.5 26V10C0.5 4.7533 4.7533 0.5 10 0.5Z",
    stroke: "#364153"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.5C17.0054 11.4946 16.4467 12.8435 16.4467 14.25C16.4467 15.6565 17.0054 17.0054 18 18C18.9946 18.9946 20.3435 19.5533 21.75 19.5533C23.1565 19.5533 24.5054 18.9946 25.5 18C25.5 19.4834 25.0601 20.9334 24.236 22.1668C23.4119 23.4001 22.2406 24.3614 20.8701 24.9291C19.4997 25.4968 17.9917 25.6453 16.5368 25.3559C15.082 25.0665 13.7456 24.3522 12.6967 23.3033C11.6478 22.2544 10.9335 20.918 10.6441 19.4632C10.3547 18.0083 10.5032 16.5003 11.0709 15.1299C11.6386 13.7594 12.5999 12.5881 13.8332 11.764C15.0666 10.9399 16.5166 10.5 18 10.5Z",
    stroke: "#364153",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkmode);
export default __webpack_public_path__ + "static/media/darkmode.fc95261a3e53205bd27a3d2faeeb2db1.svg";
export { ForwardRef as ReactComponent };